/**
 * Toast shown after a successful manifest edit.
 *
 * Editing a manifest only changes source values synchronously; the manifest's
 * discrepancies are recomputed by a background process-manifests job that runs
 * after the edit commits (ENG-15854). The copy sets that expectation so a
 * reviewer doesn't read the unchanged counts as "the edit didn't take".
 *
 * When the tracking number changes the backend creates a new manifest record;
 * surface its new number so the reviewer can follow the move.
 */
export function editManifestSuccessMessage(
  newManifest: { manifestTrackingNumber: string } | null | undefined
): string {
  const recalculating = "Discrepancies will update shortly as they recalculate in the background.";
  if (newManifest) {
    return `Manifest successfully updated. A new manifest has been created for manifest tracking number ${newManifest.manifestTrackingNumber}. ${recalculating}`;
  }
  return `Manifest successfully updated. ${recalculating}`;
}
